// extracted by mini-css-extract-plugin
module.exports = {"root":"fail_root_3dHFQ","img":"fail_img_3xIwI","text":"fail_text_3xE7Q","text2":"fail_text2_3hGbO","btn":"fail_btn_2Wc_Y"};